import * as React from 'react';

export interface IconProps {
  url: string;
  className?: string;
}

export class Icon extends React.Component<IconProps, any> {
  public render() {
    return <img className={this.props.className} src={this.props.url} />;
  }
}

export const IconDisplay = ({visible, url, classNames}) => url && visible ? <Icon className={classNames} url={url} /> : null;
